<template>
	<type-wrapper class="find_orders" regular>
		<type-grid row="13" margin>
			<type-image mode="widthFix" :src="image"></type-image>
		</type-grid>
		<type-grid row="23" margin>
			<type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
				<type-text type="title" size="9">Find Orders</type-text>
			</type-grid>
			<type-grid row="11" margin>
				<type-input whitebackdrop clearable v-model="email" placeholder="Email Address"></type-input>
			</type-grid>
			<type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
				<type-input whitebackdrop clearable v-model="order" placeholder="Order Number"></type-input>
			</type-grid>
			<type-grid row="11" margin>
				<type-button whitebackdrop border @click="findOrder">Find</type-button>
			</type-grid>
			<type-grid row="11" margin v-if="orderList.length">
				<div id="order-html">
					<div class="single-order" v-for="(item, index) in orderList" :key="index">
						<h6>Order {{index + 1}}</h6>
						<p>Order Number: {{item.order_unique_id}}</p>
						<p>Product Name: {{item.product_name}}</p>
						<p>Product Description: {{item.product_description}}</p>
						<p>Quantity: {{item.quantity}}</p>
						<p>Unit Price: {{item.final_price}}</p>
						<p>Buyer Name: {{item.receiver_name}}</p>
					</div>
				</div>
			</type-grid>
			<type-grid row="11" margin v-if="orderList.length">
				<type-button whitebackdrop v-print="'#order-html'" border>打印订单</type-button>
			</type-grid>
		</type-grid>
	</type-wrapper>
</template>

<script>
	export default {
		name: 'find_orders',
		data() {
			return {
                email: '',
                order: '',
				// email: '123@qq.com',
				// order: '2020031810210198',
				orderList: [
					// {
					// 	order_unique_id: 1,
					// 	product_name: 'xaxasdasdas',
					// 	product_description: 'xaxasdasdas',
					// 	quantity: 'xaxasdasdas',
					// 	final_price: 'xaxasdasdas',
					// 	receiver_name: 'xaxasdasdas'
					// },
					// {
					// 	order_unique_id: 2,
					// 	product_name: 'xaxasdasdas',
					// 	product_description: 'xaxasdasdas',
					// 	quantity: 'xaxasdasdas',
					// 	final_price: 'xaxasdasdas',
					// 	receiver_name: 'xaxasdasdas'
					// }
				],
				image: require('../../assets/image/about-img.jpg')
			}
		},
		methods: {
			findOrder() {
				if (!this.email && !this.order) {
					this.$message('Please enter email address or order number');
					return false;
				}
				if (this.email && (this.$verify.verifyEmail(this.email) !== true)) {
					this.$message('Please enter a valid email address');
					return false;
				}
				const req = Object.create(null);
				this.orderList = [];
				if (this.email) {
					req.customer_email = this.email;
				}
				if (this.order) {
					req.order_unique_id = this.order;
				}
                // If email is not found, only order number is found
				console.log(JSON.parse(JSON.stringify(req)))
				this.$http.order.lists(req).then(res => {
					console.log(JSON.parse(JSON.stringify(res)))
					if (res.status === 'success') {
						if (res.data.list.length) {
						    this.orderList = res.data.list;
						} else {
						    this.$message('No order information available');
						}
					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.find_orders{
		display: flex;
		flex-wrap: wrap;
        .single-order h6{
        	padding: 10px 0 5px;
        	font-weight: normal;
        }
        .single-order p{
        	color: #979797;
        	font-size: 13.5px;
        	line-height: 25px;
        	padding-bottom: 5px;
        }
	}
</style>